document.addEventListener("DOMContentLoaded", function () {
  const data = document.getElementById("ProtectedData");

// Not a protected product
if (!data) return;

const section = data.closest("section");

  const password = data.dataset.password;
  const title = data.dataset.title || "Protected Product";
  const message = data.dataset.message || "";

  // Hide product until unlocked
  section.style.visibility = "hidden";
  document.body.style.overflow = "hidden";

  // Build the modal
  const overlay = document.createElement("div");
  overlay.id = "ProtectedOverlay";

  overlay.innerHTML = `
    <div class="protected-box">
      <h2>🔒 ${title}</h2>
      <p>${message}</p>

      <input
        id="ProtectedPassword"
        type="password"
        placeholder="Enter Password"
        autocomplete="off"
      >

      <button id="UnlockProduct">
        Unlock Product
      </button>

      <p id="ProtectedError"></p>
    </div>
  `;

  // Attach directly to <body>
  document.body.appendChild(overlay);

  const input = overlay.querySelector("#ProtectedPassword");
  const button = overlay.querySelector("#UnlockProduct");
  const error = overlay.querySelector("#ProtectedError");

  input.focus();

  function unlock() {
    if (input.value === password) {
      overlay.remove();
      section.style.visibility = "";
      document.body.style.overflow = "";
    } else {
      error.textContent = "Incorrect password.";
      input.value = "";
      input.focus();
    }
  }

  button.addEventListener("click", unlock);

  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      unlock();
    }
  });
});